import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '/src/api/client';

const GoogleCallback = () => {
  const navigate = useNavigate();
  const [processed, setProcessed] = useState(false);

  useEffect(() => {
    const handleCallback = async () => {
      if (processed) return;
      
      try {
        const fragment = new URLSearchParams(window.location.hash.slice(1));
        const accessToken = fragment.get('access_token');

        if (!accessToken) {
          console.error('No access token found');
          navigate('/signin?error=no_token');
          return;
        }

        const userInfoResponse = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
          headers: { Authorization: `Bearer ${accessToken}` }
        });

        const userData = await userInfoResponse.json();
        console.log('Google user data:', userData);

        const { data: authData } = await apiClient.post('/api/v1/auth/google/callback', {
          id: userData.id,
          email: userData.email,
          name: userData.name,
          picture: userData.picture
        });

        console.log('Backend auth response:', authData);

        if (authData.token) {
          localStorage.setItem('token', authData.token);
          localStorage.setItem('userDetails', JSON.stringify(authData.user));
          setProcessed(true);
          navigate('/dashboard');
        }

      } catch (error) {
        console.error('Google auth error:', error);
        navigate('/signin?error=google_auth_failed');
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Processing Google login...</span>
      </div>
    </div>
  );
};

export default GoogleCallback;